import { createSlice } from "@reduxjs/toolkit";
import { REPORT_CALL_ANSWERED } from "../../../constants/reducer_names";

export const initialState = {
  voiceReportData: [] as any,
  voice_report_edit_columns: [] as any,
  voice_report_selected_columns:[] as any
};

const voiceReportCallSlice = createSlice({
  name: REPORT_CALL_ANSWERED,
  initialState,
  reducers: {
    ApiResultForVoiceReport: (state, { payload }) => {
      state.voiceReportData = payload.voiceReportData;
    },
    voiceReportEditColumns: (state, { payload }) => {
      state.voice_report_edit_columns = payload.voice_report_edit_columns;
    },
    voiceReportSelectedColumns: (state, { payload }) => {
      state.voice_report_selected_columns = payload.voice_report_selected_columns;
    },
    reset: () => {},
  },
});

export const reportsCallAnsweredActions = voiceReportCallSlice.actions;
export default voiceReportCallSlice.reducer;
